"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorHandler = exports.AppError = exports.LoggerModule = exports.logger = exports.Logger = void 0;
const common_1 = require("@nestjs/common");
const pino_1 = __importDefault(require("pino"));
const isServer = typeof window === 'undefined';
const defaultOptions = {
    level: process.env.LOG_LEVEL || 'info',
};
// Use browser logging on the client side
if (!isServer) {
    defaultOptions.browser = {
        write: {
            info: (...args) => console.log(...args),
            error: (...args) => console.error(...args),
            warn: (...args) => console.warn(...args),
            debug: (...args) => console.debug(...args),
        },
    };
}
class Logger {
    static getInstance() {
        if (!Logger.instance) {
            Logger.instance = (0, pino_1.default)(defaultOptions);
        }
        return Logger.instance;
    }
    info(message, context) {
        Logger.instance.info(context, message);
    }
    error(message, context) {
        Logger.instance.error(context, message);
    }
    warn(message, context) {
        Logger.instance.warn(context, message);
    }
    debug(message, context) {
        Logger.instance.debug(context, message);
    }
}
exports.Logger = Logger;
exports.logger = Logger.getInstance();
let LoggerModule = (() => {
    let _classDecorators = [(0, common_1.Global)(), (0, common_1.Module)({
            providers: [
                {
                    provide: Logger,
                    useValue: exports.logger,
                },
            ],
            exports: [Logger],
        })];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var LoggerModule = _classThis = class {
    };
    __setFunctionName(_classThis, "LoggerModule");
    (() => {
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        LoggerModule = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return LoggerModule = _classThis;
})();
exports.LoggerModule = LoggerModule;
class AppError extends Error {
    constructor(message, code, statusCode = 500, details) {
        super(message);
        this.message = message;
        this.code = code;
        this.statusCode = statusCode;
        this.details = details;
        this.name = 'AppError';
        Object.setPrototypeOf(this, AppError.prototype);
    }
}
exports.AppError = AppError;
const errorHandler = (error) => {
    if (error instanceof AppError) {
        exports.logger.error({
            error: {
                message: error.message,
                code: error.code,
                statusCode: error.statusCode,
                details: error.details,
            },
        });
        return error;
    }
    if (error instanceof Error) {
        exports.logger.error({
            error: {
                message: error.message,
                stack: error.stack,
            },
        });
    }
    else {
        exports.logger.error({ error });
    }
    return new AppError('Internal Server Error', 'INTERNAL_SERVER_ERROR', 500);
};
exports.errorHandler = errorHandler;
